// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"cd1087bd","145":"61c7f8b5","882":"14d69a1e","977":"90e3a1ac"}[chunkId] + ".chunk.js";
};